import React from "react";
import { Box } from "@mui/material";
import EtfDailyDataViewer from "../components/EtfDailyDataViewer";

export default function AdminDailyData() {
  return (
    <Box sx={{ p: 2 }}>
      <EtfDailyDataViewer
        showUpload
        title="ETF Daily Import & View"
        subtitle="Upload NSE/BSE ETF daily CSV, then view imported rows by symbol and date."
      />
    </Box>
  );
}
